import { Mail, MapPin, Instagram } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-forest text-cream pt-24 pb-10 overflow-hidden"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-cream/15">
          <div className="lg:col-span-5">
            <p className="overline text-cream/60">Alojamento Local · Portugal</p>
            <h3 className="font-display text-4xl lg:text-5xl mt-4 leading-tight">
              Casa <span className="italic">Montebello</span>
            </h3>
            <p className="mt-6 text-cream/70 max-w-md leading-relaxed">
              Um refúgio privado no meio da floresta, em Felgueiras. Feito para
              famílias e grupos que valorizam privacidade, natureza e o gosto
              de estar juntos.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="overline text-cream/60 mb-5">Contactos</p>
            <ul className="space-y-3 text-cream/80">
              <li className="flex gap-3">
                <MapPin size={16} strokeWidth={1.5} className="mt-1 shrink-0 text-terracotta" />
                <span>Felgueiras, Porto, Portugal</span>
              </li>
              <li className="flex gap-3">
                <Mail size={16} strokeWidth={1.5} className="mt-1 shrink-0 text-terracotta" />
                <a
                  href="mailto:casamontebello.pt@gmail.com"
                  data-testid="footer-email-link"
                  className="hover:text-cream transition-colors"
                >
                  casamontebello.pt@gmail.com
                </a>
              </li>
              <li className="flex gap-3">
                <Instagram size={16} strokeWidth={1.5} className="mt-1 shrink-0 text-terracotta" />
                <span>@casamontebello.pt</span>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="overline text-cream/60 mb-5">Navegar</p>
            <ul className="grid grid-cols-2 gap-y-3 text-cream/80">
              {[
                { id: "sobre", label: "Sobre" },
                { id: "comodidades", label: "Comodidades" },
                { id: "galeria", label: "Galeria" },
                { id: "testemunhos", label: "Testemunhos" },
                { id: "contactos", label: "Contactos" },
              ].map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    data-testid={`footer-nav-${l.id}`}
                    className="hover:text-cream transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-cream/50 text-sm">
          <div>© {year} Casa Montebello. Todos os direitos reservados.</div>
          <div className="flex gap-6">
            <span>RNAL · Alojamento Local</span>
            <span>Felgueiras, Porto</span>
          </div>
        </div>
      </div>

      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-24 left-1/2 -translate-x-1/2 font-display text-cream/[0.04] text-[24rem] leading-none whitespace-nowrap select-none"
      >
        Montebello
      </div>
    </footer>
  );
}
